import {
  DeleteHiringStageDocument,
  DeleteHiringStageMutation,
  DeleteHiringStageMutationVariables,
  GetHiringStagesDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useDeleteHiringStage = () => {
  const [deleteAtsHiringStage, { loading }] = useMutation(DeleteHiringStageDocument, {
    extractorFn: (data: DeleteHiringStageMutation) => data.atsMutations.deleteAtsHiringStage,
  })

  return {
    loading,
    deleteAtsHiringStage(variables: DeleteHiringStageMutationVariables) {
      return deleteAtsHiringStage({
        variables: variables,
        refetchQueries: [GetHiringStagesDocument],
      })
    },
  }
}
